module.exports = __webpack_public_path__ + "img/toolkit-specs-sample.7f2d210b.png";